import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="aspect-[21/9] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20lifestyle%20scene%20with%20fashion%20shopping%20bags%20and%20coffee%20on%20sunlit%20wooden%20cafe%20table%20golden%20afternoon%20light%20cozy%20atmosphere%20plant%20shadows%20aspirational%20yet%20relatable%20photography%20modern%20European%20cafe%20aesthetic&width=1200&height=500&seq=cta-final-revamp-01&orientation=landscape"
              alt="CSSBuy Spreadsheet products"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center mt-10 md:mt-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            {t('cta_title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('cta_subtitle')}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              {t('cta_button')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-10 py-4 border-2 border-secondary-300 text-foreground-800 rounded-full text-sm font-semibold hover:border-primary-400 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              {t('cta_secondary_button')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}